import { standardTheme } from "../../../themes";
import actions from "./actions";
import store from "store";
import { createFilter } from "react-select";
import AuthResolver from "../../auth-resolver";
import { createBrowserHistory, createMemoryHistory, createHashHistory } from "history";
import { MixpanelEvents } from "../../../modules/analytics";
export * from "./types";
var sortingOptions = [
    {
        id: 0,
        label: "Default Order",
        name: "default_order",
        value: "default_order"
    },
    {
        id: 1,
        label: "A-Z",
        name: "A-Z",
        value: "a_z"
    },
    {
        id: 2,
        label: "Z-A",
        name: "Z-A",
        value: "z_a"
    },
    {
        id: 3,
        label: "Last modified",
        name: "Last modified",
        value: "last_modified"
    }, 
];
var wrRoot = {
    state: {
        selectedRegion: "",
        phasesConfig: {
            itemGroups: []
        },
        shouldResetDecisionTree: false,
        isLoggedIn: false,
        pointSystem: false,
        proposals: [],
        cart: [],
        decisionTreeCart: {},
        decisionTreeAnswers: {},
        flow: {},
        catalogs: [],
        selectedAddons: [],
        productsValues: {},
        selectedCatalogId: null,
        filters: [],
        categoryFilters: [],
        activeFilters: [],
        activeSorting: sortingOptions[0],
        categories: [],
        user: {},
        bundles: [],
        priceFilter: {
            minValue: 0,
            maxValue: 0,
            values: [
                0,
                0
            ]
        },
        modal: {
            isOpen: false,
            body: null,
            header: null,
            footer: null
        },
        templates: []
    },
    actions: Object.assign({}, actions),
    theme: standardTheme,
    intl: function() {
        return "";
    },
    constants: {
        getSfConn: function() {
            throw new Error("Not implemented");
        },
        version: process.env.NPM_PACKAGE_VERSION,
        locale: "en",
        host: "",
        appHost: "",
        token: "",
        proposals: {
            requests: {
                fetchProposals: {
                    internalType: null
                }
            }
        },
        product: {
            list: {
                gridColSizes: {
                    sm: 6,
                    md: 4,
                    lg: 3
                }
            },
            bundles: {
                renderName: true
            },
            details: {
                displayItemRowHint: false
            },
            addToCartSkippingDetails: false
        },
        client: {
            catalogIds: [],
            companyId: "",
            addOnCatalogId: ""
        },
        transactionsEnabled: false,
        sortingOptions: sortingOptions,
        cart: {
            multiple: true,
            summaryDescription: false,
            enableQuantity: false
        },
        dropdownInput: {
            components: {
                NoOptionsMessage: function() {
                    return "No options";
                }
            },
            isSearchable: false
        },
        editor: {
            apiKey: "relrhandc0tpw1tsiz8g4we25nt4olr463welbzhj4qxj1oy",
            assetHost: "https://wr-cdn.s3.amazonaws.com/tinymce-6.2.0/",
            config: {
                height: "250",
                max_height: 800,
                plugins: "link image table lists codesample code link advlist powerpaste",
                block_formats: "Paragraph=p;Header 1=h1;Header 2=h2;Header 3=h3;Header 4=h4;Header 5=h5;Header 6=h6",
                toolbar: "blocks | bold italic underline numlist bullist | link | forecolor | indent outdent | table | codesample code | undo redo",
                codesample_dialog_height: 400,
                code_dialog_height: 400,
                branding: false,
                table_toolbar: "tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol | cell",
                menubar: "",
                powerpaste_allow_local_images: true,
                powerpaste_word_import: "prompt",
                powerpaste_html_import: "prompt",
                advlist_bullet_styles: "square circle disc",
                advlist_number_styles: "lower-roman lower-alpha default",
                autoresize_overflow_padding: 10,
                autoresize_overflow_margin: 10,
                suffix: ".min",
                theme_url: "https://wr-cdn.s3.amazonaws.com/tinymce-6.2.0/themes/silver/theme.min.js",
                base_url: "https://wr-cdn.s3.amazonaws.com/tinymce-6.2.0/",
                external_plugins: {
                    powerpaste: "https://wr-cdn.s3.amazonaws.com/tinymce-6.2.0/plugins/powerpaste/plugin.min.js"
                },
                content_style: ".mceNonEditable { opacity: 0.5; }"
            },
            tableofcontents: {
                enable: true,
                create: true,
                rebalanceHeadings: false
            }
        },
        assetsHosts: {
            faSvgIcons: "https://wr-cdn.s3.amazonaws.com/fontawesome-pro-5.14.0-web/svgs/"
        },
        requireAuth: false,
        requireSsoAuth: false,
        requirePass: false,
        skipLogicMergePreviousRangeBeforeRemoval: false,
        sso: {
            tokenStorageKey: "wrExternalUserToken",
            publicUrl: process.env.REACT_APP_SSO_PUBLIC_URL || process.env.PUBLIC_URL,
            host: process.env.REACT_APP_SSO_HOST
        },
        sfData: {},
        sfMaps: {},
        analytics: MixpanelEvents
    },
    utils: {
        product: {
            request: {
                postTransformProduct: function(item) {
                    return item;
                }
            }
        },
        products: {
            shouldDisable: function(_) {
                return false;
            },
            getFilters: function(filters) {
                return filters;
            },
            allowsMultipleSameProductsInCart: function(product) {
                return wrRoot.constants.cart.multiple;
            }
        },
        dropdownInput: {
            filteringFn: createFilter({
                matchFrom: "any",
                stringify: function(option) {
                    return "".concat(option.label);
                }
            })
        },
        transactions: {
            processTransaction: function processTransaction(_) {}
        },
        proposals: {
            requests: {
                fetchProposals: {
                    processRequestParams: function(params) {
                        return params;
                    }
                },
                createDocxRequest: null,
                createPDFRequest: null
            }
        }
    },
    routes: [
        {
            key: "index",
            component: null,
            path: "/",
            exact: true
        },
        {
            key: "tokenCallback",
            component: AuthResolver,
            path: "/token",
            exact: true
        }, 
    ],
    persistentStorage: store,
    getRoutePath: function(key, value) {
        return "";
    },
    pushRoute: function(key, value) {
        return "";
    },
    history: createBrowserHistory(),
    memoryHistory: createMemoryHistory(),
    hashHistory: createHashHistory()
};
export default wrRoot;
